import React, { useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, Redirect } from 'react-router-dom';

import LoaderBar from 'components/LoaderBar';
import FundraiserNew from './New';
import {
  fundraiserSelectors,
  getFundraiserById,
} from 'redux/slices/fundraiser';
import PATHS from 'routes/paths';
import { FIELD_NAMES } from './schema';
import { priceForAPI } from 'utils/price';

const FundraiserEdit = () => {
  const [isReady, setIsReady] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const fundraiser = useSelector((state) =>
    fundraiserSelectors.selectById(state, params.id)
  );

  useEffect(() => {
    if (fundraiser?.id) {
      setIsReady(true);
    } else {
      dispatch(getFundraiserById(params.id)).then(() => setIsReady(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isReady && !!fundraiser) {
      document.title = `Fundraiser - ${fundraiser.name} | Javelin`;
    }
  }, [fundraiser, isReady]);

  const details = useMemo(() => {
    if (!!fundraiser) {
      let _details = {
        [FIELD_NAMES.name]: fundraiser.name,
        [FIELD_NAMES.goal]: fundraiser.goal,
        [FIELD_NAMES.image]: {
          name: fundraiser.image_filename,
          path: fundraiser.image,
        },
        [FIELD_NAMES.description]: fundraiser.description,
        [FIELD_NAMES.long_description]: fundraiser.long_description,
        [FIELD_NAMES.country]: { name: fundraiser.country },
        [FIELD_NAMES.city]: fundraiser.city,
        [FIELD_NAMES.video_embed]: fundraiser.video_embed,
      };
      fundraiser.amount_options.forEach((item, idx) => {
        _details[`amount_options_${idx}`] = priceForAPI(item.amount) / 100;
      });
      return _details;
    }
    return undefined;
  }, [fundraiser]);

  if (!isReady) return <LoaderBar isVisible />;
  if (isReady && fundraiser === undefined) {
    return <Redirect to={PATHS.fundraisers} />;
  }

  return <FundraiserNew details={details} id={fundraiser.id} />;
};

export default FundraiserEdit;
